/* unplugin-vue-components disabled */import { render } from "./SopAdministration.vue?vue&type=template&id=ae05d9ee&scoped=true"
import script from "./SopAdministration.vue?vue&type=script&lang=js"
export * from "./SopAdministration.vue?vue&type=script&lang=js"

import "./SopAdministration.vue?vue&type=style&index=0&id=ae05d9ee&scoped=true&lang=css"

import exportComponent from "/home/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae05d9ee"]])

export default __exports__